import { ContentBody } from 'components/pages/components/ContentBody'
import { componentPermissions } from 'config/permissions'
import { componentNames } from 'config/roles'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { RoutePaths } from 'routes/paths'

const SimulationHub: FC = () => {
  const { t } = useTranslation()

  return <ContentBody title={t('simulationHub.title')}></ContentBody>
}

const exportObj = {
  routeProps: {
    // This gets passed straight to react-router
    path: RoutePaths.simulationCenter,
    element: <SimulationHub />,
    title: 'simulationHub.title',
    roles: componentPermissions[componentNames.pageToolsSimulationHub],
    requiresAuthentication: true,
  },
  name: 'SimulationHub',
}
export default exportObj
